import { SET_NOTIFICATION, SET_PROMPT } from '../types'

const reducer = (state, action) => {
  switch (action.type) {
    case SET_NOTIFICATION:
      return {
        ...state,
        notification: action.payload,
      }
    case SET_PROMPT:
      return {
        ...state,
        prompt: action.payload,
      }
    default:
      return state
  }
}

export default reducer
